// react
import React from 'react';

// third-party
import { Link } from 'react-router-dom';

// application
import StroykaSlick from '../shared/StroykaSlick';
import axios from "axios";
import {useProductsContext} from "../../providers/DataProvider";
import {getMediaCallsUrl} from "../../utils/localSwitch";

const slickSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 400,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            },
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            },
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
    ],
};

export default function BlockBrands() {
    const {stateData} = useProductsContext();
    const {brands} = stateData;

    const brandsList = brands.map((brand, index) => (
        <div key={index} className="block-brands__item">
            <Link to="/"><img src={getMediaCallsUrl() + brand.attributes.logo.data.attributes.url} alt={brand.attributes.title} /></Link>
        </div>
    ));

    return (
        <React.Fragment>
            {brands.length !== 0 && <div className="block block-brands">
                <div className="container">
                    <div className="block-brands__slider">
                        <StroykaSlick {...slickSettings}>
                            {brandsList}
                        </StroykaSlick>
                    </div>
                </div>
            </div>}
        </React.Fragment>
    );
}
